<template>
    <div id="content" :class="{'d-flex flex-column justify-content-center': coreParams.all_private_albums && +coreParams.all_private_albums}">
        <div v-if="coreParams.all_private_albums && +coreParams.all_private_albums" class="container">
            <div class="hidden-album-box">
                <div class="hidden-album-box-title">{{ $t('private_gallery') }}</div>
                <div class="row">
                    <div class="col-md-7">
                        <div class="hidden-album-box-text">{{ $t('descriptions.personal_albums') }}</div>
                        <div v-if="coreParams.shop_design && coreParams.shop_design.info_text" class="hidden-album-box-text">
                            <hr><div v-html="coreParams.shop_design.info_text"></div>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <hidden-album-form :label="!isMobile" position="top"/>
                    </div>
                </div>
            </div>
        </div>
        <template v-else>
            <breadcrumbs :page="categoryName" :show-password-field="true" offset-top="0"/>
            <div class="container">
                <div class="row">
                    <div class="col-lg-8">
                        <albums :items="items" :cols="2"/>
                        <b-pagination
                                v-if="perPage > 0 && rows && rows > items.length"
                                v-model="currentPage"
                                :total-rows="rows"
                                :per-page="perPage"
                                :limit="isMobile ? 3 : 4"
                                aria-controls="my-table">
                            <template v-slot:first-text>
                                <span class="material-icon icon-first_page"></span>
                            </template>
                            <template v-slot:prev-text>
                                <span class="material-icon icon-keyboard_arrow_left"></span>
                            </template>
                            <template v-slot:next-text>
                                <span class="material-icon icon-keyboard_arrow_right"></span>
                            </template>
                            <template v-slot:last-text>
                                <span class="material-icon icon-last_page"></span>
                            </template>
                        </b-pagination>
                    </div>
                    <div class="col-lg-4">
                        <album-categories/>
                        <latest-albums v-if="!isMobile"/>
                    </div>
                </div>
            </div>
        </template>
        <powered-by v-if="hasPoweredBy"/>
        <vue-headful :title="headTitle($t('gallery'))"/>
    </div>
</template>

<script>
  import HiddenAlbumForm from '../components/HiddenAlbumForm.vue';
  import Albums from '../components/Albums.vue';
  import PoweredBy from '../components/PoweredBy.vue';
  import AlbumCategories from '../components/menu/AlbumCategories.vue';
  import LatestAlbums from '../components/menu/LatestAlbums.vue';
  import Breadcrumbs from '../components/Breadcrumbs.vue';

  import allAlbums from 'src/mixins/allAlbumsPage';

  export default {
    mixins: [allAlbums],
    components: {
      HiddenAlbumForm,
      Albums,
      PoweredBy,
      AlbumCategories,
      LatestAlbums,
      Breadcrumbs,
    },
  };
</script>
